module.exports = global["$"] = require("-!/Users/uzhu/Desktop/lb/修改备案/uzhu-pms-web/node_modules/expose-loader/index.js?jQuery!/Users/uzhu/Desktop/lb/修改备案/uzhu-pms-web/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/jquery/dist/jquery.js-exposed
// module id = 217
// module chunks = 64